<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-07 16:31:55
-->
<template>
  <div class="exportStateCell">
      <div class="flex flex-align-center">
          <div :class="['state_icon', row.export_status == '1' ? 'success' : 'danger']" v-if="row[column.key]"></div>
          <i class="el-icon-loading loading" v-else></i>
          <p class="ml-6">{{ row['export_status_desc'] }}</p>
      </div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin]
}
</script>
<style lang="less" scoped>
.state_icon{
    width: 8px;
    height: 8px;
    border-radius: 50%;
}
.success{
    background-color: @color-success;
}
.danger{
    background-color: @color-danger;
}
.loading {
    color: @color-primary;
}
</style>